<ng-template *ngIf="!dqChatPanelService.isChatPanelVisible" reusable-outlet-chat [reusableComponent]="reusableComponents.DQ_CHAT_PANEL"></ng-template>
